"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react"; // Added import for React

import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ArrowUp, Mail } from "lucide-react";
import { GithubIcon } from "@/ui/svg/github";
import { LinkedinIcon } from "@/ui/svg/linkedin";
import { StackoverflowIcon } from "@/ui/svg/stackoverflow";
import { XIcon } from "@/ui/svg/x";
export function Footer() {
  const $ = _c(18);
  const [pathname, setPathname] = useState("/");
  const path = usePathname();
  let t0;
  let t1;
  if ($[0] !== path || $[1] !== pathname) {
    t0 = () => {
      if (path !== pathname) {
        setPathname(path);
      }
    };
    t1 = [pathname, path];
    $[0] = path;
    $[1] = pathname;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  const t2 = `${pathname}#top`;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowUp />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Link href={t2} scroll={true} className="text-muted-foreground ring-foreground/50 hover:text-foreground appearance-none rounded-full text-sm ring-1 transition-colors">{t3}</Link>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href="mailto:andrew@windycitydevs.io" className="text-muted-foreground hover:text-foreground transition-colors"><span className="sr-only">Email</span><Mail className="h-5 w-5" /></a>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <a href="https://linkedin.com/asross" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors"><span className="sr-only">LinkedIn</span><LinkedinIcon className="h-5 w-5" /></a>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <a href="https://x.com/Dopamine_Driven" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground appearance-none transition-colors"><span className="sr-only">X (Twitter)</span><XIcon className="h-5 w-5" /></a>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <a href="https://github.com/DopamineDriven" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors"><span className="sr-only">GitHub</span><GithubIcon className="h-5 w-5" /></a>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <a href="https://stackoverflow.com/users/13243520/andrew-ross?tab=profile" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors"><span className="sr-only">Stack Overflow</span><StackoverflowIcon className="h-5 w-5" /></a>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4) {
    t10 = <div className="mx-auto flex flex-col gap-4 md:flex-row md:items-center md:justify-between"><div className="mx-auto flex items-center justify-between gap-x-4">{t4}{t5}{t6}{t7}{t8}{t9}</div></div>;
    $[12] = t4;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <hr className="border-muted-foreground/20 my-8" />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="text-muted-foreground text-sxs text-center">©{new Date().getFullYear()} Andrew Ross. All rights reserved.</p>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10) {
    t13 = <footer className="theme-transition bg-background text-foreground max-w-10xl mt-8 p-4"><div className="container mx-auto max-w-7xl px-6 text-center">{t10}{t11}{t12}</div></footer>;
    $[16] = t10;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
}